import { Grid, Tab, Tabs } from '@mui/material';
import React from 'react'
import { useRecoilValue } from 'recoil';
import { EEScorecardAtom } from '../../../../State/EEScorecard.Atom';
import { TabPanel, tabPropsFunc } from '../../../Base/Account/Account';
import { GoalsAndTargets } from './GoalsAndTargets'
import { GoalsAndTargetsNew } from './GoalsAndTargetsNew';
import config from '../../../../config';

export const WorkforceProfileBase = () => {
  const [tabValue, setTabValue] = React.useState<number>(0);

  const eeScorecard = useRecoilValue(EEScorecardAtom);
  const [workforceSnapshotDate, setWorkforceSnapshotDate] = React.useState<Date>(new Date(eeScorecard.ReportPeriodDateTo));

  const handleTabValueChanged = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  }

  const onDateChange = (newdate : Date) => {
    setWorkforceSnapshotDate(newdate);
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        <Tabs value={tabValue} onChange={handleTabValueChanged} aria-label="Tabs" centered>
          <Tab label="All Employees" {...tabPropsFunc(0)} />
          <Tab label="Disabled Employees" {...tabPropsFunc(1)} />
        </Tabs>
        <TabPanel value={tabValue} index={0}>
          {config.enable_new_EE_workforce_tables === 'true' ? (
            <GoalsAndTargetsNew disabled={false} workforceProfileDate={workforceSnapshotDate} onDateChange={onDateChange} />
          ) : (
            <GoalsAndTargets disabled={false} workforceProfileDate={workforceSnapshotDate} onDateChange={onDateChange} />
          )}
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
          {config.enable_new_EE_workforce_tables === 'true' ? (
              <GoalsAndTargetsNew disabled={true} workforceProfileDate={workforceSnapshotDate} onDateChange={onDateChange} />
            ) : (
              <GoalsAndTargets disabled={true} workforceProfileDate={workforceSnapshotDate} onDateChange={onDateChange} />
            )}
        </TabPanel>
      </Grid>
    </Grid>
  )
}
